import * as PROJECT_CODE from '../../constants/projectCode';
import firebase from '../../lib/firebase.prod';

const firebaseRef = firebase.database();

export default async function createSessionAppointment(
	email,
	displayName,
	userType,
	phoneNumber,
	userUid,
	setLoading,
	disableNav
) {
	disableNav(true);
	var dateObj = new Date().getTime();

	var createNewAppointment = await firebase
		.functions()
		.httpsCallable('CreateMeetingFromData');

	var detailsForCall = {
		thisEmail: email,
		thisName: displayName,
		thisAppointmentCode: 'meeting',
		thisAppointmentTime: dateObj,
		thisUserType: userType,
		thisPhone: phoneNumber,
		thisUID: userUid,
	};

	var appointmentPost = {
		appointmentID: 'none',
		appointmentName: 'Adhoc_Appointment_Made_by_Admin_',
		timeOfAppointment: dateObj,
		assignedTo: 'Adhoc',
		started: false,
		createrID: userUid,
		sentRemind: false,
		createUser: false,
		instantVideoCall: true,
		projectCode: PROJECT_CODE.projectCode,
	};

	var shortLongCode;

	var users = {
		0: {
			email: 'null',
			fullName: 'null',
			phoneNumber: 'null',
		},
	};

	appointmentPost['users'] = users;

	await createNewAppointment(appointmentPost)
		.then((result) => {
			shortLongCode = result.data;
			setLoading(false);
		})
		.catch(function (error) {
			console.log('Error ' + error);
		});

	detailsForCall['shortCode'] = shortLongCode.shortCode;
	detailsForCall['thisAppointmentCode'] = shortLongCode.longCode;

	return detailsForCall;
}
